import { Permission } from "@/lib/permissions/Permission.enum";

export enum UserManagementTabs {
  USERS = "users",
  INVITED_USERS = "invited-users",
  GROUPS = "groups",
  ORPHANED_WORKSPACES = "orphaned-workspaces",
}

/** The permission each tab's export needs — it matches the endpoint the export reads from. */
export const EXPORT_PERMISSION: Record<UserManagementTabs, Permission> = {
  [UserManagementTabs.USERS]: Permission.ReadRoles,
  [UserManagementTabs.INVITED_USERS]: Permission.ReadOrganizationInvitation,
  [UserManagementTabs.GROUPS]: Permission.ReadGroups,
  [UserManagementTabs.ORPHANED_WORKSPACES]: Permission.ManageOrphanedWorkspaces,
};

/**
 * The permission each tab's bulk-edit mode needs, or `null` where the tab has no bulk mode.
 * A tab without one still reserves the slot, so the button never moves between tabs.
 */
export const BULK_EDIT_PERMISSION: Record<
  UserManagementTabs,
  Permission | null
> = {
  [UserManagementTabs.USERS]: Permission.UpdateUserRoles,
  [UserManagementTabs.INVITED_USERS]: null,
  [UserManagementTabs.GROUPS]: Permission.UpdateFeatureGroups,
  [UserManagementTabs.ORPHANED_WORKSPACES]: Permission.ManageOrphanedWorkspaces,
};
